import { Component, Input } from '@angular/core';

@Component({
  selector: 'eiq-grid-bulk-actions-row',
  templateUrl: 'grid-bulk-actions-row.component.html',
  styleUrls: ['grid-bulk-actions-row.component.scss', '_grid-bulk-actions-row-theme.component.scss']
})
export class GridBulkActionsRowComponent {
  @Input() itemDescription: string;
  @Input() selectedCount: number;
}
